
import React from 'react';
import { Badge } from "@/components/ui/badge";

const MarkdownImportGuide = () => {
  return (
    <div className="rounded-md border bg-card p-4 mt-4">
      <h3 className="text-lg font-medium mb-2 flex items-center gap-2">
        Markdown Format Guide
        <Badge variant="markdown">Markdown</Badge>
      </h3>
      
      <div className="text-sm space-y-3">
        <p className="text-muted-foreground">
          Each prompt should follow this format in your markdown file:
        </p>
        
        <div className="bg-muted p-3 rounded font-mono text-xs overflow-x-auto">
          <pre>{`# Prompt Title

## Description
A description of what this prompt does

## Prompt
The actual prompt content text goes here.
This can span multiple lines.

## Category
category-slug

## Source
optional-source-url`}</pre>
        </div>
        
        <div className="space-y-1 mt-2">
          <p className="text-muted-foreground font-medium">Important formatting rules:</p>
          <ul className="list-disc list-inside pl-2 text-muted-foreground">
            <li>Start each prompt with <code className="bg-muted px-1"># Title</code></li>
            <li>Follow each section header immediately with content (no blank lines between)</li>
            <li>Section headers must be formatted exactly as shown</li>
            <li>Category must match an existing category slug</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MarkdownImportGuide;
